/**
 * Settings Manager
 * 
 * Handles persistent settings using localStorage.
 * Ported from SharedObject functionality in Flash
 */

export class Settings {
    constructor() {
        this.storageKey = 'cityPlanner_settings';
        this.defaults = {
            showGridlines: true,
            showBuildingLevels: true,
            water: false,
            wood_weight: 1.0,
            stone_weight: 1.0,
            iron_weight: 1.0,
            food_weight: 1.0,
            gold_weight: 1.0
        };
        
        this.data = this.load();
    }
    
    /**
     * Load settings from localStorage
     */
    load() {
        try {
            const stored = localStorage.getItem(this.storageKey);
            if (stored) {
                const parsed = JSON.parse(stored);
                return { ...this.defaults, ...parsed };
            }
        } catch (error) {
            console.warn('Failed to load settings:', error);
        }
        return { ...this.defaults };
    }
    
    /**
     * Save settings to localStorage
     */
    save() {
        try {
            localStorage.setItem(this.storageKey, JSON.stringify(this.data));
        } catch (error) {
            console.warn('Failed to save settings:', error);
        }
    }
    
    /**
     * Get a setting value
     */
    get(key) {
        return this.data[key] !== undefined ? this.data[key] : this.defaults[key];
    }
    
    /**
     * Set a setting value
     */
    set(key, value) {
        this.data[key] = value;
        this.save();
    }
    
    /**
     * Reset to defaults
     */
    reset() {
        this.data = { ...this.defaults };
        this.save();
    }
}

// Export singleton
export const settings = new Settings();

